import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import config from "../../config";
import { getLanguageHeaders } from "../services/http-common";
import { extractApiErrorPayload, getApiErrorMessages } from "../../utilities/handleApiValidationError";
import { clearAllPersistedFilters } from "../../utilities/persistListFilters";

export const LoginHand = createAsyncThunk("login/LoginHand", async (userData, thunkAPI) => {
    const { rejectWithValue, fulfillWithValue, dispatch } = thunkAPI
    try {
        const response = await fetch(`${config.apiUrl}/login`, {
            method: "POST",
            body: JSON.stringify(userData),
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                ...getLanguageHeaders(),
            }

        })

        const data = await response.json();
        if (!response.ok) {
            return rejectWithValue(data)
        } else {
            const normalizedPayload = {
                token: data?.token ?? data?.data?.token ?? null,
                user: data?.user ?? data?.data?.user ?? null,
                message: data?.message ?? data?.data?.message ?? "Login successful"
            }

            dispatch(authentication(normalizedPayload))

            if (typeof window !== "undefined") {
                window.location.assign("/")
            }

            return fulfillWithValue(normalizedPayload)
        }
    } catch (error) {
        return rejectWithValue({ message: error?.message ?? "Unexpected error" })
    }
})


export const LoginSlice = createSlice({
    name: "login",
    initialState: { user: null, token: null, error: null, errorMessages: [], fieldErrors: null, loading: false },
    reducers: {
        authentication: (state, action) => {
            const { token, user } = action.payload || {}

            state.token = token ?? null
            state.user = user ?? null

            if (typeof window !== "undefined") {
                clearAllPersistedFilters()

                if (token) {
                    localStorage.setItem("jwt", token)
                } else {
                    localStorage.removeItem("jwt")
                }

                if (user) {
                    localStorage.setItem("user", JSON.stringify(user))
                } else {
                    localStorage.removeItem("user")
                }
            }
        },
    },
    extraReducers: {
        [LoginHand.pending]: (state, action) => {
            state.loading = true
            state.error = null
            state.errorMessages = []
            state.fieldErrors = null
        },
        [LoginHand.fulfilled]: (state, action) => {
            state.loading = false
            state.user = action.payload?.user ?? null
            state.token = action.payload?.token ?? null
            state.error = null
            state.errorMessages = []
            state.fieldErrors = null
        },
        [LoginHand.rejected]: (state, action) => {
            state.loading = false
            const messages = getApiErrorMessages(action.payload, 'Unable to login')
            state.errorMessages = messages
            state.error = messages[0] ?? 'Unable to login'
            state.fieldErrors = extractApiErrorPayload(action.payload)?.errors ?? null
        },
    }
})

export default LoginSlice.reducer;
export const { authentication } = LoginSlice.actions